module.exports = __webpack_public_path__ + "img/download-image.e2d1e5ee.svg";